import { Router } from '@angular/router';
import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { ConfigService } from '../../../services/config/config.service';
import {
  LayoutSettings,
  PredefinedTemplatesService,
} from '../../../services/edit/predefined-templates.service';

@Component({
  selector: 'ag-logo-title[settings]',
  templateUrl: './logo-title.component.html',
  styleUrls: ['./logo-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LogoTitleComponent implements OnChanges {
  @Input() settings: { layoutSettings: LayoutSettings; libraryName: string };
  @Input() responsive = true;

  titleLength: number;

  showLogo = false;
  showTitle = false;

  title: string;
  titleHover = null;
  imageUrl: string;
  redirectUrl: string;

  constructor(
    private _router: Router,
    private _configService: ConfigService,
    private _predefinedTemplatesService: PredefinedTemplatesService,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.settings) {
      if (changes.settings.currentValue == null) {
        throw new TypeError('"settings" cannot be null or undefined');
      }
      this._bindSettings(changes.settings.currentValue.layoutSettings);
    }
  }

  goToUrl() {
    if (/\S/.test(this.redirectUrl) && this.redirectUrl != null && this.redirectUrl) {
      let link = '';
      if (this.redirectUrl.includes('http://') || this.redirectUrl.includes('https://')) {
        link = this.redirectUrl;
      } else {
        link = 'https://' + this.redirectUrl;
      }
      window.open(link, '_blank');
    } else {
      const obj = { type: 'primary page' };
      this._predefinedTemplatesService.underlineActivePage(obj);
      this._router.navigate(['/'], {
        queryParams: {
          cid: this.settings.layoutSettings.cid,
          lid: this.settings.layoutSettings.lid,
        },
      });
    }
  }

  private _bindSettings(settings: LayoutSettings) {
    this.showLogo = settings.showLogo || settings.logoAndText;
    this.showTitle = settings.showLogo != true;

    this.imageUrl = this._configService.baseUrl + settings.logoImageURL;
    this.redirectUrl = settings.logoRedirectURL;

    if (settings.logoAndText || settings.showTitle) {
      this.title = settings.customText;
    } else {
      this.title = this.settings.libraryName;
    }
    this.titleHover = settings.name ?? '';
  }
}
